import Header from "./Organisms/Header/Header";
import Intro from "./Organisms/Intro/Intro";

Header();
Intro();
